var path = 'topBar.html';
var html = "<header class=header data-ng-cloak data-ng-class=\"{'header-push': (mobile && sidebarActive)}\"> <div class=header-inner data-ng-class=\"{'header-inner--left': !mobile }\"> <a whispeer-sref=app.main class=header-brand data-ng-click=mobileActivateView()> <img src=/assets/img/logo/white_darker.svg alt=whispeer class=header-brand__logo> </a> </div> </header> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/topBar.html
// module id = 5FY0
// module chunks = 1